<template>
  <div class="mHeader-section">
    <div class="mHeader-container">
      <div class="left-menu">
         <div class="social-networks" :class="{onlySafari: isSafari}">
            <a
              id="facebook"
              class="social-icon"
              target="_blank"
              href="https://www.facebook.com/cervezaindio/" @click="socialClick('Facebook','Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'header')"
              ><img :src="fbIconImage" alt="Facebook"
            /></a>
            <a
              id="instagram"
              class="social-icon"
              target="_blank"
              href="https://www.instagram.com/cervezaindio/" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'header')"
              ><img :src="inIconImage" alt="Instagram"
            /></a>
            <a
              id="twitter"
              class="social-icon"
              target="_blank"
              href="https://twitter.com/cervezaindio" @click="socialClick('Twitter','Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'header')"
              ><img :src="twIconImage" alt="Twitter"
            /></a>
            <a
              id="youtube"
              class="social-icon"
              target="_blank"
              href="https://www.youtube.com/user/cervezaindio" @click="socialClick('Youtube','Interaction') & socialGA4Click('click', 'redes sociales :: youtube', 'header')"
              ><img :src="ytIconImage" alt="Youtube"
            /></a>
          </div>
          <!-- <div class="div-rock">
            <a class="rock_id" href="https://www.indio.com.mx/rockid">ROCK ID</a>
          </div> -->
          <!-- <div
            @click="selectMobileOption('campaigns') & headerGA4Click('click', 'campañas', 'header')"
            :class="{ active: getActiveSection === 'campaigns' }"
          >
            <h2>CAMPAÑAS</h2>
          </div> -->
          <!-- <div class="div-rock">
            <a class="rock_id" @click="headerGA4Click('click', 'código indio', 'header')" href="https://indio.com.mx/documentales/">CÓDIGO INDIO</a>
          </div> -->
          <div
            @click="selectMobileOption('history') & headerGA4Click('click', 'historia', 'header')"
            :class="{ active: getActiveSection === 'history' }"
          >
            <h2>HISTORIA</h2>
          </div>
          <div
          @click="selectMobileOption('beer') & headerGA4Click('click', 'cerveza indio', 'header')"
          :class="{ active: getActiveSection === 'beer' }"
        >
          <h2>CERVEZA INDIO</h2>
        </div>
      </div>
      <div class="mLogo-container">
        <img
          @click="selectMobileOption('campaigns') & headerGA4Click('click', 'campañas', 'header')"
          :src="indioIcon"
          alt="Logo de Indio"
        />
      </div>
      <div class="right-menu" :class="{onlySafari: isSafari}">
        <!-- <div
          @click="selectMobileOption('sustainable')"
          :class="{ active: getActiveSection === 'sustainable' }"
        >
          <h2>COMPROMISO <br> SUSTENTABLE</h2>
        </div> -->
        <!-- <div
          @click="selectMobileOption('beer') & headerGA4Click('click', 'cerveza indio', 'header')"
          :class="{ active: getActiveSection === 'beer' }"
        >
          <h2>CERVEZA INDIO</h2>
        </div> -->
        <div
           @click="selectMobileOption('retailers') & headerGA4Click('click', 'donde comprar', 'header')"
          :class="{ active: getActiveSection === 'retailers' }"
        >
          <h2>DÓNDE COMPRAR</h2>
        </div>
        <div class="div-button">
          <a class="nft-button" @click="headerGA4Click('click', 'indio agave', 'header')" href="https://indio.com.mx/indioagave">INDIO AGAVE</a>
        </div>
        <!-- <div class="div-button">
          <a class="nft-button" target="_blank" href="http://cervezaindionft.com/">NFT</a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import indioIcon from "@/assets/Indio_Logo_Simple.png";
import fbIcon from "@/assets/fbIcon.png";
import twIcon from "@/assets/twIcon.png";
import ytIcon from "@/assets/ytIcon.png";
import inIcon from "@/assets/instaIcon.png";

import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'
import Bowser from "bowser"; 

export default {
  name: "Menu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action) {
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    headerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ path: option }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
      this.openMenu();
    },
  },
  data() {
    return {
      isMenuOpen: false,
      indioIcon,
      fbIconImage: fbIcon,
      twIconImage: twIcon,
      ytIconImage: ytIcon,
      inIconImage: inIcon,
      isSafari: false
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/menum.scss";
</style>
